import Vue from 'vue'
import Router from 'vue-router'
import MyAccount from '@/components/MyAccount'
import MyServices from '@/components/MyServices'
import MyNetDevices from '@/components/MyNetDevices'
import MyFindocs from '@/components/MyFindocs'
import PersonalDetails from '@/components/PersonalDetails'
import Login from '@/components/Login'
import TokenLogin from '@/components/TokenLogin'
import Logout from '@/components/Logout'
import ResetPassword from '@/components/ResetPassword'
import ResetPasswordConfirm from '@/components/ResetPasswordConfirm'
import PaymentFinished from '@/components/PaymentFinished'
import ReferralInfo from '@/components/ReferralInfo'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:usernamedigits(\\d+)',
      name: 'login-prefill-username',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/login/:token',
      name: 'login-by-token',
      component: TokenLogin
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword
    },
    {
      path: '/reset-password/:id',
      name: 'reset-password-confirm',
      component: ResetPasswordConfirm
    },
    {
      path: '/services',
      name: 'my-services',
      component: MyServices
    },
    {
      path: '/devices',
      name: 'my-net-devices',
      component: MyNetDevices
    },
    {
      path: '/account',
      name: 'my-account',
      component: MyAccount
    },
    {
      path: '/findocs',
      name: 'my-findocs',
      component: MyFindocs
    },
    {
      path: '/personal',
      name: 'my-personal-details',
      component: PersonalDetails
    },
    {
      path: '/payment-finished/:ordernumber',
      name: 'payment-finished',
      component: PaymentFinished
    },
    {
      path: '/referral',
      name: 'referral-program',
      component: ReferralInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js